import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { FrameOne } from '../components/FrameOne';
import { FrameTwo } from '../components/FrameTwo';
import { FrameThree } from '../components/FrameThree';
import { FrameFour } from '../components/FrameFour';
import { FrameFive } from '../components/FrameFive';
import { FrameSix } from '../components/FrameSix';
import { OrderStageView } from '../components/OrderStageView';
import { QualityReport } from '../components/QualityReport';
import { ClientCallLogAll } from '../components/ClientCallLogAll';
import { styleSheet } from '../styles/styleSheet';

import { fetchquoteid } from '../actions/fetchquoteid';
import { fetchClientCallLog } from '../actions/fetchClientCallLog';
import { setquotedata, setCertificateData, generateCertificate } from '../actions/setquotedata';
import { setvendordata } from '../actions/setvendordata';
import { setincdata } from '../actions/setincdata';
import { setnextactiondate } from '../actions/setnextactiondate';
import { setcitydata } from '../actions/setcitydata';
import { addOrUpdate, updateStructureVendor, updateMppVerificationStatus, updateFeasiblityStatus, updateAcdbDcdbVariable, updateQualityVisitStatus, updatePPAVariable, updateCustomerVideoUrlVariable, updateLoanBankIfsc, updateSelectedPlan } from '../actions/addorupdatewebportal';
import { fetchPeTaskByQuoteId } from '../actions/peTaskV2Actions.js';
import { generateDocument, fetchDocuments, downloadDocument } from '../actions/documentActions.js';
import { setloanissue } from '../actions/setloanissue';
import { setebissue } from '../actions/setebissue';
import { setorderstatus } from '../actions/setorderstatus';
import { setuserinfo } from '../actions/setuserinfo';
import { setresponsible } from '../actions/setresponsible';
import { setnotification } from '../actions/setnotification';
import { setottdata } from '../actions/setottdata';
import { setPayments } from '../actions/setPayments';
import { setNetMeteringDate } from '../actions/setNetMeteringDate';
import { Restrict } from '../components/Restrict'
import { Loader } from "../components/Loader.jsx";
import { fileUpload, fileDownload } from '../actions/fileUploadActions/fileUpload';
import { sendEmailOnEdit } from '../actions/sendEmailOnEdit';
import { sendEmailLayout } from '../actions/sendEmailLayout';
import { sendUploadedFileEmail } from '../actions/sendUploadedFileEmail';
import { setPanelVendorData } from '../actions/setPanelVendorData';
import { openlog } from '../actions/openlog';
import {verify ,reject } from '../actions/verify';
import {generateOtp,verifyOtp} from '../actions/generateAndVerifyOtpPanelVendor';
import { sendFeedbackMsg } from '../actions/sendFeedbackMsg';
import { setPincode } from '../actions/setPincodeData';
import {changeZunprimeStatus} from '../actions/changeZunrpimeStatus';
import { setInvoiceVerificationStatus } from '../actions/setInvoiceVerificationStatus';
import { fetchrequestlistbyquoteid } from '../actions/fetchvendortickets.js';
import { requestNewTransaction } from '../actions/setvendortickets';
import { fetchmapping } from '../actions/fetchmapping';

class QuoteId extends Component {

	componentWillMount() {
		if(this.props.user){
			if(this.props.user.level>=1600){
				this.props.fetchquoteid(this.props.match.params.id);
				this.props.fetchClientCallLog(this.props.match.params.id);
				this.props.fetchrequestlistbyquoteid(this.props.match.params.id, [ 'v2', 'structure', 'Adjustment' ], [ 1, 2, 3 ]);
				this.props.fetchPeTaskByQuoteId(this.props.match.params.id);
				this.props.fetchDocuments(this.props.match.params.id);
				this.props.fetchmapping();
			}
		}
	}

	render() {
		if(this.props.user===null){
			return <Redirect to={"/login?redirect_uri=quoteid/"+this.props.match.params.id} />;
		}

		if(this.props.user && this.props.user.level<1600) {
			return (
				<div>
					<Restrict />
				</div>
			)
		}

		if(this.props.data.length>0) {
			// console.log("Naman",this.props.data[5]);
			console.log("Site Id",this.props.data[7]);
			return (
				<div style = {styleSheet.frameOne} className="container-fluid">
					{this.props.addingComment?<div  className="alert alert-warning" role="alert">PLEASE WAIT...</div>:""}
					<FrameOne deliveryComment={this.props.data[31]} amcData={this.props.data[29]} setPincode={this.props.setPincode} sendFeedbackMsg={this.props.sendFeedbackMsg} generateCertificate={this.props.generateCertificate} setCertificateData={this.props.setCertificateData} generateVerifyOtp={this.props.generateVerifyOtp} generateOtp={this.props.generateOtp} verifyOtp={this.props.verifyOtp} fileUpload={this.props.fileUpload} fmsData={this.props.data[19]} setNetMeteringDate={this.props.setNetMeteringDate} setresponsible={this.props.setresponsible} teamEmployeeMap={this.props.data[14]} employeeMap={this.props.data[13]} subsidyStatusMap={this.props.data[12]} netMeteringStagesMap={this.props.data[25]} fileType={this.props.data[18]} fileDownload={this.props.fileDownload} stateD={this.props.data[10]} setuserinfo={this.props.setuserinfo} setorderstatus={this.props.setorderstatus} subsidyD={this.props.data[11]} stages={this.props.data[9]} ebissues={this.props.data[8]} data={this.props.data[4]} siteid={this.props.data[7]} user={this.props.user} system={this.props.data[5]} setvendordata={this.props.setvendordata} setPanelVendorData={this.props.setPanelVendorData} sendEmailOnEdit={this.props.sendEmailOnEdit} setincdata={this.props.setincdata} setnextactiondate={this.props.setnextactiondate} setebissue={this.props.setebissue} setcitydata={this.props.setcitydata} addorupdate={this.props.addOrUpdate} setloanissue={this.props.setloanissue} stateToCityMap={this.props.data[20]} stateToDiscomMap={this.props.data[21]} panelVendorMap={this.props.data[22]} vendorList={this.props.data[26]} siteVisitStatus={this.props.data[27]} structureVendors={this.props.data[28]} updateStructureVendor={this.props.updateStructureVendor} updateMppVerificationStatus={this.props.updateMppVerificationStatus} updateFeasiblityStatus={this.props.updateFeasiblityStatus} panelDeliveryStatus={this.props.data[32]} inverterDeliveryStatus={this.props.data[33]} isProjectDelayed={this.props.data[34]} changeZunprimeStatus={this.props.changeZunprimeStatus} updateAcdbDcdbVariable={this.props.updateAcdbDcdbVariable} updateQualityVisitStatus={this.props.updateQualityVisitStatus} updatePPAVariable={this.props.updatePPAVariable} updateLoanBankIfsc={this.props.updateLoanBankIfsc} updateCustomerVideoUrlVariable = {this.props.updateCustomerVideoUrlVariable}
					vendorPayments={this.props.vendorPaymentsQuoteId || []} vendorMap={this.props.vendorMap || {}} currentStage={this.props.data[35]} setquotedata = {this.props.setquotedata} commentsData={this.props.data[3]} quoteIdTasks={this.props.quoteIdTasks} generateDocument={this.props.generateDocument} documents={this.props.documents} downloadDocument={this.props.downloadDocument} requestNewTransaction={this.props.requestNewTransaction} vendorTicketError={this.props.vendorTicketError} vendorTicketSuccess={this.props.vendorTicketSuccess} updateSelectedPlan={this.props.updateSelectedPlan}/>
					<FrameTwo setPayments = {this.props.setPayments} siteid={this.props.data[7]} sendEmailOnEdit={this.props.sendEmailOnEdit} setottdata={this.props.setottdata} user={this.props.user} ottPayments = {this.props.data[16]} system = {this.props.data[5]} payments = {this.props.data[1]} bill={this.props.data[0]} finalprice={this.props.data[6]} data = {this.props.data[4]}/>
					<OrderStageView data={this.props.data[35]}/>
					{
						this.props.user.level>=1600?<FrameSix sendUploadedFileEmail={this.props.sendUploadedFileEmail} emailLayout={this.props.emailLayout} uploadFile={this.props.uploadFile} fmsData={this.props.data[19]} siteid={this.props.data[7]} quoteDetails = {this.props.data[4]} user={this.props.user} system = {this.props.data[5]} fileType={this.props.data[18]} fileUpload={this.props.fileUpload} fileDownload={this.props.fileDownload} sendEmailLayout={this.props.sendEmailLayout} mandatorydocs={this.props.data[23]} openlog={this.props.openlog} docs={this.props.data[24]} verify={this.props.verify} reject ={this.props.reject} log={this.props.log} setInvoiceVerificationStatus={this.props.setInvoiceVerificationStatus} setquotedata = {this.props.setquotedata}/>:""
					}
					<QualityReport data={this.props.data[30]} user={this.props.user} />
					<FrameThree notificationMap = {this.props.data[15]} setnotification = {this.props.setnotification} user={this.props.user} siteid={this.props.data[7]} quoteDetails = {this.props.data[4]} data = {this.props.data[2]}/>
					{/* <FrameFour user={this.props.user} setquotedata = {this.props.setquotedata} siteid={this.props.data[7]} data = {this.props.data[3]}/> */}
					{this.props.user.level>=1600?<FrameFive data={this.props.data[17]} user={this.props.user} />:""}
					<ClientCallLogAll data={this.props.totalCallData} user={this.props.user} />
				</div>
			);
		}

		return (
			<div style = {styleSheet.frameOne} className="container-fluid">
				<Loader />
			</div>
		);
	}
}


function mapStateToProps(state) {
	console.log(state);
	let { error = "", success = "" } = state.vendortickets || {};
	return {
		user : state.user,
		data : state.data,
		addingComment:state.status.comment,
		uploadFile:state.uploadfile,
		totalCallData : state.clientcall.totalCallData,
		emailLayout : state.sendemaillayout.data,
		log : state.openlog.log,
		generateVerifyOtp : state.generateverifyotppanel.data,
		vendorPaymentsQuoteId: (state.vendortickets || {}).referenceListQuoteId || [],
		vendorMap: (state.mapping || {}).vendorMap || [],
		quoteIdTasks: (state.pedata || {}).tableData || [],
		documents: (state.quoteIdDocuments || {}).documents || [],
		vendorTicketError: error,
		vendorTicketSuccess: success
	};
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ sendUploadedFileEmail, fetchquoteid, fetchClientCallLog, setPayments, setNetMeteringDate, setottdata, setresponsible, setuserinfo, setorderstatus, setquotedata, setvendordata, setPanelVendorData, setincdata, setnextactiondate, setcitydata, addOrUpdate, setloanissue, setebissue, setnotification, fileUpload, fileDownload, sendEmailLayout, sendEmailOnEdit, openlog, verify, reject, generateOtp, verifyOtp, updateStructureVendor, setCertificateData, generateCertificate, sendFeedbackMsg, setPincode, updateMppVerificationStatus, updateFeasiblityStatus, changeZunprimeStatus, setInvoiceVerificationStatus, updateAcdbDcdbVariable, updateQualityVisitStatus, updatePPAVariable, updateLoanBankIfsc, updateCustomerVideoUrlVariable, fetchrequestlistbyquoteid, fetchmapping, fetchPeTaskByQuoteId, generateDocument, fetchDocuments, downloadDocument, requestNewTransaction, updateSelectedPlan}, dispatch)
};

export default connect(mapStateToProps,mapDispatchToProps)(QuoteId);
